import React from 'react';
import { variables } from '@splunk/themes';
import styled from 'styled-components';
import { SuggestionEntry } from '../dashboard/DrilldownButton';

const StyledSuggestionsContainer = styled.div`
    background: transparent;
    padding-right: 12px;
    color: ${variables.contentColorDefault};

    &:before {
        display: none;
    }
`;

export const DrilldownSuggestionContainer = ({
    suggestions,
    onClick,
}: {
    suggestions: Array<SuggestionEntry>;
    onClick: (name: string) => void;
}): React.JSX.Element => (
    <StyledSuggestionsContainer className="variable-suggestion-container">
        <div className="variable-suggestion-box">
            <div className="variable-container">
                Available variables
                <br />
                (click or type &#123;&#123;&#123; to insert):
            </div>
            <div className="separator"></div>
            {suggestions.map((suggestion, index) => (
                <div
                    className="variable"
                    key={`${suggestion.name}-${index}`}
                    onClick={(): void => onClick(suggestion.name)}
                >
                    <div>
                        <span>&#123;&#123;&#123; </span>
                        {suggestion.name}
                        <span> &#125;&#125;&#125;</span>
                    </div>
                    <div className="variable-description">Current value: {suggestion.value}</div>
                </div>
            ))}
        </div>
    </StyledSuggestionsContainer>
);
